/* eslint-disable no-async-promise-executor */
import { Alert } from 'antd';
import { Bitrix24Context } from 'contexts/legacy/Bitrix24Context';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import React from 'react';
import { api } from 'services/api';

class Bitrix24Provider extends React.Component {
	state = {
		user: {
			NAME: '',
		},
		onbitrix: false,
		gotostep: false,
		bitrix_connector: process.env.REACT_APP_BITRIX_CONNECTOR,
		onbitrixFunction: false,
		authentication_failure: false,
		channels: [],
		used_channels: [],
		placement: null,
		isAdmin: false,
		loadingChannels: true,
		channelsError: false,
		loadingClient: true,
		params: {
			LANG: 'en',
			DOMAIN: '',
		},
		infos: {
			domain: '',
			auth: '',
		},
		installationErrors: [],
		auth: {},
		loadingLinking: false,
		loadingListOfNumbers: false,
		loadingListOfNumbersForMobile: false,
		listOfNumbers: [],
		listOfNumbersFromMobile: [],
		getNumberFromCRM: this.getNumberFromCRM.bind(this),
		getCurrentUserContext: this.getCurrentUserContext.bind(this),
		// getNumberFromCRMInMobileApp: this.getNumberFromCRMInMobileApp.bind(this),
		linkChannel: this.linkChannel.bind(this),
		listChannelsOnBitrix: this.listChannelsOnBitrix.bind(this),
		unlinkChannel: this.unlinkChannel.bind(this),
		setParams: this.setParams.bind(this),
	};

	async componentDidMount() {
		const domain = 'solinka.bitrix24.com';

		try {
			// window.BX24.init(() => {
			window.BX24.init(() => {
				const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
				this.setState({ auth });
				const domain = auth.domain;
				const lang = window.BX24 ? window.BX24.getLang() : 'en';
				api.defaults.headers['Content-Language'] = lang;

				this.setState({ domain });
				this.setState({ lang });

				window.BX24.callMethod('user.current', {}, async (res) => {
					let user = res.data();

					user = user || {
						ID: '',
						NAME: '',
						EMAIL: '',
						PERSONAL_PHONE: '',
					};

					const stado = {
						onbitrix: true,
						onbitrixFunction: true,
						user,
						placement: window.BX24.placement.info(),
						isAdmin: window.BX24.isAdmin(),
					};

					this.setState(stado);

					window.BX24.fitWindow();

					await this.loadClientInfos(domain)
						.then((data) => {
							if (!this.props.step) {
								this.listChannelsOnBitrix(data);
								this.getNumberFromCRM(data);
							}
						})
						.catch((e) => {
							this.setState({
								authentication_failure: e.authentication_failure,
							});
							if (e.authentication_failure && this.state.isAdmin) {
								const request = {
									action: 'restoreToken',
									domain: this.state.auth.domain,
									access_token: this.state.auth.access_token,
									refresh_token: this.state.auth.refresh_token,
									auth: this.state.infos.auth,
								};

								api.post('restoreToken', request).then((res) => {
									if (res.data.status) {
										window.location.reload();
									}
								});
							}
						});
				});
			});
		} catch (e) {
			await this.loadClientInfos(domain).then(() => {
				if (!this.props.step) {
					this.listChannelsOnBitrix();
				}
			});
			this.setState({ onbitrix: false, onbitrixFunction: false });
		}
	}

	async getNumberFromCRM(data) {
		if (this.state.placement) {
			this.setState({ loadingListOfNumbers: true });
			const request = {
				action: 'getNumberFromCRM',
				domain: data.domain,
				auth: data.auth,
				...this.state.placement,
			};

			await api.post('getNumberFromCRM', request).then((res) => {
				this.setState({ loadingListOfNumbers: false });
				if (res.data.status) {
					this.setState({ listOfNumbers: res.data.dados });
				}
			});
		}
	}

	async listChannelsOnBitrix(data) {
		// return new Promise(async (resolve, reject) => {
		this.setState({ loadingChannels: true, channelsError: false });
		const request = {
			action: 'listChannelOnBitrix',
			domain: data.domain,
			auth: data.auth,
		};

		// await api.post("", request).then(res => {
		await api
			.post('listChannelOnBitrix', request)
			.then((res) => {
				this.setState({ loadingChannels: false, channelsError: !res.data.status });
				if (res.data.status) {
					this.setState({ channels: res.data.dados });
					this.setState({ used_channels: res.data.used_channels });
				}
			})
			// Sem isto, falha de rede deixava o spinner da tela de canais girando para sempre.
			.catch(() => this.setState({ loadingChannels: false, channelsError: true }));
		// });
	}

	linkChannel(numberId, channelId) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingLinking: true });
			const request = {
				action: 'addEditNumber',
				domain: this.state.infos.domain,
				auth: this.state.infos.auth,
				id: parseInt(numberId),
				channel_id: parseInt(channelId),
			};

			// await api.post("", request).then(res => {
			await api.post('addEditNumber', request).then((res) => {
				this.setState({ loadingLinking: false });
				if (res.data.status) {
					if (this.state.onbitrixFunction) {
						window.BX24.callMethod(
							'imconnector.activate',
							{
								CONNECTOR: this.state.bitrix_connector,
								LINE: parseInt(channelId),
								ACTIVE: 'Y',
							},
							(result) => {
								if (result.error()) {
									reject(result.error());
								} else {
									resolve(res.data);
								}
							},
						);
					} else {
						resolve(res.data);
					}
				} else {
					reject(res.data);
				}
			});
		});
	}

	async setParams(value) {
		return new Promise(async (resolve) => {
			await this.setState({ params: value }, () => {
				resolve();
			});
		});
	}

	unlinkChannel(numberId, channelId) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingLinking: true });
			const request = {
				action: 'addEditNumber',
				domain: this.state.infos.domain,
				auth: this.state.infos.auth,
				id: parseInt(numberId),
				channel_id: -1,
			};

			// await api.post("", request).then(res => {
			await api.post('addEditNumber', request).then((res) => {
				this.setState({ loadingLinking: false });
				if (res.data.status) {
					if (this.state.onbitrixFunction) {
						window.BX24.callMethod(
							'imconnector.activate',
							{
								CONNECTOR: this.state.bitrix_connector,
								LINE: parseInt(channelId),
								ACTIVE: 'N',
							},
							(result) => {
								if (result.error()) {
									reject(result.error());
								} else {
									resolve(res.data);
								}
							},
						);
					} else {
						resolve(res.data);
					}
				} else {
					reject(res.data);
				}
			});
		});
	}

	async loadClientInfos(domain) {
		this.setState({ loadingClient: true });
		const request = {
			action: 'getClient',
			domain,
		};

		try {
			const res = await api.post('getClient', request);
			this.setState({ loadingClient: false });

			if (res.data.status) {
				this.setState({
					infos: res.data.dados,
					installationErrors: JSON.parse(res.data.dados.installation_errors),
					gotostep: res.data.dados.tour === 0,
				});
				return res.data.dados;
			} else {
				throw res.data;
			}
		} catch (error) {
			this.setState({ loadingClient: false });
			throw error;
		}
	}

	async getCurrentUserContext(domain, memberId) {
		try {
			const user = await new Promise((resolve, reject) => {
				window.BX24.init(() => {
					window.BX24.callMethod('user.current', {}, (res) => {
						if (res.error()) {
							reject(res.error());
						} else {
							resolve(res.data());
						}
					});
				});
			});

			const context = {
				userId: user?.ID || null,
				domain,
				memberId,
			};

			return context;
		} catch (error) {
			console.error('getCurrentUserContext::Exception', error);
			throw error;
		}
	}

	render() {
		if (!this.state.onbitrix) {
			return (
				<Alert
					message="API WhatsApp Integration"
					description="Loading application API WhatsApp Integration"
					type="info"
					showIcon
					style={{ margin: 20 }}
				/>
			);
		}

		return (
			<Bitrix24Context.Provider value={this.state}>{this.props.children}</Bitrix24Context.Provider>
		);
	}
}

export default SystemConsumer(Bitrix24Provider);
